type Result =
	| {
			isValid: false;
	  }
	| {
			isValid: true;
			integerPart: number;
	  };

/**
 * Parses a user-provided string into a non-negative integer amount, ignoring any
 * locale-specific grouping separators, currency symbols, and whitespace.
 *
 * Uses `decimalSeparator` to locate the integer portion of the value; everything
 * after the separator is dropped (cents are not preserved).
 */
export function parseLocalizedDecimalAmount(value: string, decimalSeparator: string): Result {
	if (value === '') return { isValid: true, integerPart: 0 };

	if (!/\d/.test(value)) return { isValid: false };

	const separatorIndex = value.indexOf(decimalSeparator);
	const integerSection = separatorIndex === -1 ? value : value.slice(0, separatorIndex);

	const integerDigits = integerSection.replace(/\D/g, '');
	const integerPart = Number(integerDigits || '0');

	if (!Number.isSafeInteger(integerPart)) return { isValid: false };

	return { isValid: true, integerPart };
}
